<template>
  <div
    class="container w-screen h-screen flex flex-col items-center justify-center gap-4 px-16"
  >
    <div class="font-semibold text-lg text-white tracking-widest">用户登录</div>
    <el-input v-model="loginForm.userName" placeholder="用户名"></el-input>
    <el-input type="password" v-model="loginForm.password" placeholder="密码"></el-input>
    <div class="flex items-center gap-8">
      <el-input v-model="loginForm.code" placeholder="验证码"></el-input>
        <img
          id="codeBox"
          height="40px"
          style="vertical-align: middle; cursor: pointer"
          border="0"
          :src="checkCodeSrc"
          @click="changeCode"
        />
    </div>
    <div class="flex justify-between w-full gap-6">
      <el-button class="flex-1" @click="goHome">取消</el-button>
      <el-button class="flex-1" type="primary" @click="submitLoginInfo"
        >登录</el-button
      >
    </div>
  </div>
</template>

<script>
import { loginStatusConfig } from "../config";
import { userLogin } from "../api/login";
import md5 from "js-md5"; //md5

export default {
  data() {
    return {
      checkCodeSrc: this.GlobalConfig.baseUrl + "/login/login_code.jsp",
      loginForm: {
        username: "",
        password: "",
        code: "",
      },
      loginRules: {
        userName: { required: true, message: "请输入用户名" },
        password: { required: true, message: "请输入密码" },
        code: { required: true, message: "请输入验证码" },
      },
    };
  },
  methods: {
    goHome(){
      this.$router.push('/')
    },
    changeCode() {
      const dt = new Date().getTime();
      this.checkCodeSrc =
        this.GlobalConfig.baseUrl + "/login/login_code.jsp?dt=" + dt;
      this.loginForm.code = ""; //验证码框置空
    },
    // 简单验证器
    validateForm() {
      return Object.keys(this.loginRules).every((key) => {
        if (!!this.loginRules[key].required && !this.loginForm[key]) {
          this.$message.error(this.loginRules[key].message);
          return false;
        }
        return true;
      });
    },
    // 提交登录信息
    async submitLoginInfo() {
      if (!this.validateForm()) {
        return false; // 验证未通过
      }
      //form data表单提交
      let fd = new FormData();
      fd.append("userName", this.loginForm.userName);
      fd.append("password", md5(this.loginForm.password));
      fd.append("code", this.loginForm.code);
      const data = await userLogin(fd);

      localStorage.setItem("headStatus", "nav");
      if (data?.code == 2) {
        //刷新当前页面
        this.$store.dispatch('getLoginStatus');
        this.$router.go(-1);
      } else if (data?.code == 3) {
        //刷新当前页面
        this.$store.dispatch('getLoginStatus');
        this.$message.error("密码多日未变，请修改密码");
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      } else {
        const errMsg =
          loginStatusConfig.get(data?.code) || loginStatusConfig.get("default");
        this.$message.error(errMsg);
        this.changeCode();
      }
    },
  },
};
</script>
<style scoped>
.container {
  background-image: linear-gradient(
    45deg,
    #002b9e 0%,
    #2b5ba5 30%,
    #f0f2f7 100%
  );
}
</style>
